import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export default function PublicOnly({ children }) {
  const { status } = useAuth();

  // cât timp verificăm /auth/me
  if (status === "unknown") {
    return <div className="p-4 text-center">Se verifică sesiunea...</div>;
  }

  // dacă ești deja autentificat, mergi la dashboard
  if (status === "authenticated") {
    return <Navigate to="/app" replace />;
  }

  // altfel, randăm pagina publică (login / forgot / reset)
  return children;
}